import { defineComponent as _defineComponent } from 'vue'
import { CardData, CardType } from '~/composables/useCardData';
import { defaultThumbnailOnError } from '~/utils/image';


export default /*#__PURE__*/_defineComponent({
  __name: 'CardImage',
  props: {
    item: null,
    type: null
  },
  setup(__props: any) {



return { __sfc: true,defaultThumbnailOnError }
}

})